import { MEMBERSHIP_RATE_DISPLAY_PERIODS } from 'src/models/circuit/Circuit'
import MembershipType from 'src/models/membership-type/MembershipType'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/Model'
import UserClass from 'src/models/user-class/UserClass'

export default class MembershipUserType extends Model {
  static name = 'MembershipUserType'

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      membershipType: {
        type: MembershipType,
        encode: encoders.hasOne,
        reference: true,
        output: true
      },
      userClass: {
        type: UserClass,
        encode: encoders.hasOne,
        reference: true
      },
      monthlyRate: {
        type: Number,
        encode (data) {
          if (this.configuration.currentCircuit.membershipRateDisplayPeriod === MEMBERSHIP_RATE_DISPLAY_PERIODS.MONTHLY) data.monthlyRateCentsHundredths = Math.round(this.monthlyRate * 100 * 100) // * dollars * cents hundredths
        },
        default: 19.95
      },
      additionalMonthlyRate: {
        type: Number,
        encode (data) {
          if (this.configuration.currentCircuit.membershipRateDisplayPeriod === MEMBERSHIP_RATE_DISPLAY_PERIODS.MONTHLY) data.additionalMonthlyRateCentsHundredths = Math.round(this.additionalMonthlyRate * 100 * 100) // * dollars * cents hundredths
        },
        default: 15
      },
      yearlyRate: {
        type: Number,
        encode (data) {
          // * dollars * cents hundredths * months + rounded for no thousandths of cents
          if (this.configuration.currentCircuit.membershipRateDisplayPeriod === MEMBERSHIP_RATE_DISPLAY_PERIODS.YEARLY) data.monthlyRateCentsHundredths = Math.round(this.yearlyRate * 100 * 100 / 12)
        },
        default: 19.95 * 12
      },
      additionalYearlyRate: {
        type: Number,
        encode (data) {
          // * dollars * cents hundredths * months + rounded for no thousandths of cents
          if (this.configuration.currentCircuit.membershipRateDisplayPeriod === MEMBERSHIP_RATE_DISPLAY_PERIODS.YEARLY) data.additionalMonthlyRateCentsHundredths = Math.round(this.additionalYearlyRate * 100 * 100 / 12)
        },
        default: 15 * 12
      }
    }
  }
}
